module.exports = __webpack_public_path__ + "static/media/redevistorias.6de900be.svg";